import salesApi from '@/api/sales.api';

const state = {
  packages: [],
  package: null,
  status: '',
};

const getters = {
  packages: state => state.packages,
  package: state => state.package,
  status: state => state.status,
};

const actions = {
  async findPackages({ commit }, { query }) {
    try {
      commit('SET_STATUS', 'LOADING');
      const response = await salesApi.findPackages({ query });
      commit('SET_PACKAGES', response.packages);
      commit('SET_STATUS', 'FINISHED');
    } catch (error) {
      commit('SET_STATUS', 'ERROR');
      console.error('Error fetching packages:', error);
      throw error;
    }
  },

  async getPackage({ commit }, packageId) {
    try {
      commit('SET_STATUS', 'LOADING');
      const response = await salesApi.getPackage(packageId);
      commit('SET_PACKAGE', response.package);
      commit('SET_STATUS', 'FINISHED');
    } catch (error) {
      commit('SET_STATUS', 'ERROR');
      console.error('Error fetching package:', error);
      throw error;
    }
  },

  async createPackage({ dispatch }, packageData) {
    try {
      await salesApi.createPackage(packageData);
      dispatch('findPackages', { query: '' });
    } catch (error) {
      console.error('Error creating package:', error);
      throw error;
    }
  },

  async updatePackage({ dispatch }, packageData) {
    try {
      await salesApi.updatePackage(packageData._id, packageData);
      dispatch('findPackages', { query: '' });
    } catch (error) {
      console.error('Error updating package:', error);
      throw error;
    }
  },

  async activatePackage({ dispatch }, packageId) {
    try {
      await salesApi.updatePackage(packageId, { isActive: true });
      dispatch('findPackages', { query: '' });
    } catch (error) {
      console.error('Error activating package:', error);
      throw error;
    }
  },

  async deactivatePackage({ dispatch }, packageId) {
    try {
      await salesApi.updatePackage(packageId, { isActive: false });
      dispatch('findPackages', { query: '' });
    } catch (error) {
      console.error('Error deactivating package:', error);
      throw error;
    }
  },

  async deletePackage({ dispatch }, packageId) {
    try {
      await salesApi.deletePackage(packageId);
      dispatch('findPackages', { query: '' });
    } catch (error) {
      console.error('Error deleting package:', error);
      throw error;
    }
  },
};

const mutations = {
  SET_PACKAGES(state, packages) {
    state.packages = packages;
  },
  SET_PACKAGE(state, packageData) {
    state.package = packageData;
  },
  SET_STATUS(state, status) {
    state.status = status;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}; 